const toPrice = amount =>
  isNaN(amount) ? null : `${amount < 0 ? '- ' : ''}$${parseFloat(Math.abs(amount)).toFixed(2)}`

export default toPrice
